import type { AxiosInstance, CancelTokenStatic } from 'axios'
import axios from 'axios'
import { baseURL } from './api'

const TOKEN_KEY = 'token'

const setToken = (token: string) => localStorage.setItem(TOKEN_KEY, token)

const getToken = () => localStorage.getItem(TOKEN_KEY)

const clearToken = () => localStorage.removeItem(TOKEN_KEY)

const getHeaders = () => {
	const token = getToken()

	if (!token) {
		return null
	}

	return {
		Authorization: `api_token ${token}`,
	}
}

const instance: AxiosInstance & { CancelToken?: CancelTokenStatic } =
	axios.create({
		baseURL,
		withCredentials: true,
	})

// instance.interceptors.request.use(function(config) {
//   config.headers[config.method] = {
//     ...config.headers[config.method],
//     ...getHeaders()
//   }

//   return config
// })

instance.CancelToken = axios.CancelToken

export { apiHost, apiVersion, baseURL, network } from './api'
export * from './client'
export * from './Provider'
export { clearToken, getHeaders, instance as axios, setToken }
